// extracted by mini-css-extract-plugin
export default {"LogoutBtn":"LogoutBtn_LogoutBtn__QEn1b","icon":"LogoutBtn_icon__tJLVB"};